import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";
import settings from "../utils/settings";

const useOneUser = (id) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function getOneUser(id) {
      try {
        const member = await dataProvider.getOne("merchant-users", { id: id });
        setUser(member.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        return setError(error);
      }
    }

    setLoading(true);
    getOneUser(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reload = async (id) => {
    try {
      const member = await dataProvider.getOne("merchant-users", { id: id });
      setUser(member.data);
      return setLoading(false);
    } catch (error) {
      return setError(error);
    }
  };

  return { user, loading, error, reload };
};

async function loadOneUser(id) {
  const { token } = settings();

  try {
    const result = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/merchant-users/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );

    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.merchant_user, null];
    } else {
      return [null, "Error"];
    }
  } catch (error) {
    return null;
  }
}

export default useOneUser;
export { loadOneUser };
